module.exports = __webpack_public_path__ + "static/img/2-4.fee16b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/2-4.jpg
// module id = ySpI
// module chunks = 25